import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './style.css'
import router from './router/router'
import i18n from './i18n'

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')

// Add debugging to verify i18n is loaded
console.log('i18n loaded with locales:', Object.keys(i18n.global.messages.value))
